import Send from '../../send';

const DEFAULT_API = '/v1/terms-info';
export default {
    getTermsInfos(siteInfoSeq) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'GET',
            params : {
                siteInfoSeq : siteInfoSeq
            }
        });
    },

    createTermsInfo(siteInfoSeq, termsInfoDTO) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'POST',
            params : {
                siteInfoSeq : siteInfoSeq
            },
            data : termsInfoDTO
        });
    },

    updateTermsInfo(seq, termsInfoDTO) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'PUT', 
            data : termsInfoDTO
        });
    },

    deleteTermsInfo(seq) {
        Send({
            url : `${DEFAULT_API}`,
            method : 'DELETE',
            params : {
                termsInfoSeq : seq
            }
        });
    },
    searchTermsInfos(siteInfoSeq, searchInfo, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/searchTermsInfos?page=${pageNumber}`,
            method : 'GET',
            params : {
                siteInfoSeq : siteInfoSeq,
                boardSearchType : searchInfo.boardSearchType,
                searchValue : searchInfo.searchValue
            }
        });

    }
}